import { render, staticRenderFns } from "./TotalExtendido.vue?vue&type=template&id=9db94732&scoped=true&"
import script from "./TotalExtendido.vue?vue&type=script&lang=ts&"
export * from "./TotalExtendido.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9db94732",
  null
  
)

export default component.exports